module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-2"
  }, [_vm._v("Mary Mac’s Tea Room")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }), _c('span', {
    staticClass: "Normal CharOverride-2"
  }, [_vm._v("75th Anniversary Cookbook")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(" text copyright © 2019 by John Ferrell. All rights reserved. ")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("No part of this book may be used or reproduced in any")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(" manner whatsoever without written permission except in the case of reprints in the context of reviews. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("Andrews McMeel Publishing, LLC ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("an Andrews McMeel Universal company ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("ISBN: 978-")]), _c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("-5248-6030-1")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("Library of Congress Control Number: 2019941313")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("Design: Pinafore Press/Janice Shay")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("Photography: Deborah Whitlaw Llewellyn")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("Additional photography: Brad Newton, pages ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub#_idTextAnchor000"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("ii")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub2#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("v")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor107"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("21")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub12#_idTextAnchor460"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("181")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; George Felker, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub7#_idTextAnchor192"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("53")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Georgia Tech Athletics/Danny Karnik, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor333"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("113")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; courtesy of Governor Deal’s office, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub12#_idTextAnchor473"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("191")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Terrell Clark, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor320"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("103")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Tracy Flanagan, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor425"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("157")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; courtesy of Bob Barr’s office, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor335"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("114")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Matt Thompson, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor323"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("105")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Sarah Newman Photography, page ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub5#_idTextAnchor052"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("xii")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("; Angie Mosier, pages ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor095"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("9")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor111"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("25")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor117"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("28")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub6#_idTextAnchor118"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("29")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub7#_idTextAnchor173"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("39")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub7#_idTextAnchor182"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("47")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub8#_idTextAnchor243"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("72")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub8#_idTextAnchor244"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("73")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub8#_idTextAnchor248"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("76")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub9#_idTextAnchor331"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("111")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub10#_idTextAnchor358"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("119")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub10#_idTextAnchor360"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("120")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor391"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("133")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor393"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("134")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor396"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("136")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor400"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("140")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor413"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("149")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor422"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("155")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub11#_idTextAnchor428"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("158")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub12#_idTextAnchor465"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("185")])]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(", ")]), _c('a', {
    attrs: {
      "href": "#/Mary_Mac_Final_epub12#_idTextAnchor488"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('a', {
    attrs: {
      "href": "http://www.marymacs.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("www.marymacs.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t"
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please e-mail the Andrews McMeel Publishing Special Sales Department: ")]), _c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "Normal CharOverride-1"
  }, [_vm._v("specialsales@amuniversal.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180d9893","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mary_Mac_Final_epub-1.vue
// module id = 60
// module chunks = 0